import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-prescription-old',
	templateUrl: './prescription-old.component.html',
	styleUrl: './prescription-old.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class PrescriptionOldComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	caseDetails: any = {};
	pageLoading1 = false;
	pagetitle: string = "Prescription";
	File_Storage_URL = environment.File_Storage_URL;

	public medArray: Array<any> = [];
	public medArrayTemp: Array<any> = [];
	saveMedLoader = false;
	showMedHistory = true;
	selectedFreq: any = {};
	printPrescArray: any = [];
	casePrescPdfList: any = [];
	prescriptionPara: any = {
		prescUserType: 'Candidate',
		chief_complaint: null,
		prescDoctor: null
	}
	generatePdfLoader = false;
	blob: any = null;
	newblob: any = null;
	mealsList: any = ["Before", "After"];
	doctorList: any = [];
	minDate = datePickerMinDate;
	medicineMaster: any[] = [];
	searchKeyword: string = '';
	isLoading: any = null;
	loaadingIndex: number | null = null;
	private searchTerms = new Subject<string>();

	constructor(private http: HttpClient, private sanitizer: DomSanitizer, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.getAllDoctors();
			}
		})
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/prescription/" + this.uId, name: this.pagetitle });
			this.getCaseDetails();
			/* this.getAllDoctors(); */
			this.getCaseMedicines();
			this.casePrescPdfHistory();
			this.searchTerms.pipe(
				debounceTime(500),
				distinctUntilChanged(),
				tap(() => this.isLoading = this.loaadingIndex),
				switchMap(term => this.apiService.getMedicine({ draw: 1, start: 0, length: 50, searchVal: term }))
			).subscribe({
				next: (res: any) => {
					this.medicineMaster = res.data.map((med) => med.name);
					this.isLoading = null;
				}, error: () => {
					this.isLoading = null;
				}
			});
		});
	}

	onInputChanged(query: string, index: number): void {
		this.loaadingIndex = index;
		this.searchTerms.next(query);
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getCaseMedicines() {
		this.apiService.getPrescription({ id: this.uId, flag: "meds" }).subscribe({
			next: (data: any) => {
				try {
					this.medArray = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.medArray = [];
				}
				try {
					this.medArrayTemp = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.medArrayTemp = [];
				}
				for (let i = 0; i < this.medArray.length; i++) {
					try {
						this.medArray[i].medDate = new Date(this.medArray[i].medDate);
						if (this.medArray[i].medDate instanceof Date && !isNaN(this.medArray[i].medDate)) {

						} else {
							this.medArray[i].medDate = null;
						}
					} catch (error) {
						this.medArray[i].medDate = null;
					}
					this.medArray[i].isSaved = true;
					/* this.medicineMasterListArray.push([]); */
					try {
						if (!isNaN(this.medArray[i].noOfDays) && this.medArray[i].medDate) {
							let medDate: any = new Date(this.medArray[i].medDate);
							medDate.setHours(0, 0, 0, 0);
							let noOfDays: any = parseInt(this.medArray[i].noOfDays);
							const today: any = new Date();
							today.setHours(0, 0, 0, 0);
							const diffTime: any = Math.abs(today - medDate);
							const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
							if (diffDays >= noOfDays && this.medArray[i].status == "Started") {
								this.medArray[i].status = "Completed";
							}
						}
					} catch (error) { }
					this.medArray[i].isCheckedForMail = true;
					if (this.medArray[i].status == "Stopped" || this.medArray[i].status == "Completed") {
						this.medArray[i].showCheckboxForMail = false;
					} else {
						this.medArray[i].showCheckboxForMail = true;
					}
				}
			}, error: (error) => {
				this.medArray = [];
				this.medArrayTemp = [];
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch case details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getAllDoctors() {
		/* this.apiService.getDoctorList({}).subscribe({
			next: (data: any) => {
				this.doctorList = data.data;
			}, error: (error) => {
				this.doctorList = [];
			},
		}); */
		this.doctorList = this.navbar.filterDoctors();
	}

	getDateStringFromDateYMD(date: any) {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = year + "/" + monthStr + "/" + dayStr;
		return fromStr;
	}

	getDateStringFromDateDMY(date: any) {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = dayStr + "/" + monthStr + "/" + year;
		return fromStr;
	}

	medSection() {
		this.showMedHistory = !this.showMedHistory;
		this.printPrescArray = [];
	}

	casePrescPdfHistory() {
		this.apiService.casePrescriptionList({ id: this.uId, flag: "prescription" }).subscribe({
			next: data => {
				this.casePrescPdfList = data;
			}, error: (error) => {
				this.casePrescPdfList = [];
			}
		});
	}

	copyMedicinesToClipBoard(num: number) {
		var tableId = "medicineTempTableToCopy" + num;
		let tblStr = '<ul id="' + tableId + '">';
		for (let i = 0; i < this.medArray.length; i++) {
			tblStr += '<li>';
			tblStr += this.medArray[i].medDate ? this.getDateStringFromDateDMY(new Date(this.medArray[i].medDate)) : "";
			tblStr += ' - ';
			tblStr += this.medArray[i].name;
			tblStr += ' - ';
			tblStr += this.medArray[i].qty;
			tblStr += '-';
			tblStr += this.getFrequencyText(this.medArray[i]);
			tblStr += ' - ';
			tblStr += this.medArray[i].meals;
			tblStr += " meal";
			if (this.medArray[i].noOfDays != undefined && this.medArray[i].noOfDays != null && this.medArray[i].noOfDays !== "") {
				tblStr += ' - ';
				tblStr += this.medArray[i].noOfDays;
				tblStr += ' days';
			}
			tblStr += ' - ';
			tblStr += this.medArray[i].status;
			tblStr += '-';
			tblStr += this.medArray[i].notes ? ' - ' + this.medArray[i].notes : "";
			tblStr += '</li>';
		}
		tblStr += '</ul>';
		$("#medicineTempTableContainerForCopy" + num).html(tblStr);
		this.selectElementContents(tableId);
		$("#medicineTempTableContainerForCopy" + num).html("");
	}

	getFrequencyText(obj: any) {
		let textArr: any = [];
		if (obj.morning) {
			textArr.push("Morning");
		}
		if (obj.afternoon) {
			textArr.push("Afternoon");
		}
		if (obj.evening) {
			textArr.push("Evening");
		}
		if (obj.sos) {
			textArr.push("SOS");
		}
		return textArr.length ? textArr.join(", ") : "-";
	}

	selectElementContents(id: any) {
		var el: any = document.getElementById(id);
		var body: any = document.body;
		var range: any;
		var sel: any;
		if (document.createRange && window.getSelection) {
			range = document.createRange();
			sel = window.getSelection();
			sel.removeAllRanges();
			try {
				range.selectNodeContents(el);
				sel.addRange(range);
			} catch (e) {
				range.selectNode(el);
				sel.addRange(range);
			}
			document.execCommand('copy');
			sel.removeAllRanges();
			this.toastr.success("Copied to clipboard", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		} else if ($(body).createTextRange) {
			range = $(body).createTextRange();
			range.moveToElementText(el);
			range.select();
			this.toastr.error("Unable to copy", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	loadPdf() {
		if (!this.prescriptionPara.prescDoctor) {
			this.toastr.error("Please select doctor.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let address = '';
		let mobOrEmail = '';
		let cand_dob: any = "";
		if (this.caseDetails.dob) {
			try {
				let curDate = new Date();
				let candDOB = new Date(this.caseDetails.dob.split("-").reverse().join("/"));
				let candDOBYear = candDOB.getFullYear();
				let curYear = curDate.getFullYear();
				cand_dob = curYear - candDOBYear;
			} catch (error) {
				cand_dob = "";
			}
		}
		if (this.prescriptionPara.prescUserType == 'Candidate') {
			address = this.caseDetails.address || '-';
			mobOrEmail = this.caseDetails.email || this.caseDetails.tel_no || "-";
		} else {
			address = this.caseDetails.vessel || '-';
			/* mobOrEmail = this.caseDetails.vesselEmail || "-"; */
			mobOrEmail = this.caseDetails.vessel || "-";
		}
		let prescDetails: any = {};
		prescDetails.candName = this.caseDetails.f_name + " " + this.caseDetails.l_name;
		prescDetails.caseId = this.caseDetails.case_id;
		prescDetails.id = this.uId;
		prescDetails.gender = this.caseDetails.gender;
		prescDetails.prescribeBy = this.prescriptionPara.prescDoctor ? this.prescriptionPara.prescDoctor.name : "";
		prescDetails.address = address;
		prescDetails.mobOrEmail = mobOrEmail;
		prescDetails.chief_complaint = this.prescriptionPara.chief_complaint;
		prescDetails.cand_dob = cand_dob.toString();
		prescDetails.doctor = this.prescriptionPara.prescDoctor ? this.prescriptionPara.prescDoctor.id : null;
		let finalMeds: any = [];
		if (this.printPrescArray.length > 0) {
			for (let i = 0; i < this.printPrescArray.length; i++) {
				finalMeds.push({
					name: this.printPrescArray[i]["name"],
					qty: this.printPrescArray[i]["qty"] != undefined ? this.printPrescArray[i]["qty"] : "",
					meals: this.printPrescArray[i]["meals"] != undefined ? this.printPrescArray[i]["meals"] : "",
					noOfDays: this.printPrescArray[i]["noOfDays"],
					status: this.printPrescArray[i]["status"] != undefined ? this.printPrescArray[i]["status"] : "",
					notes: this.printPrescArray[i]["notes"] != undefined ? this.printPrescArray[i]["notes"] : "",
					morning: this.printPrescArray[i]["morning"] != undefined ? this.printPrescArray[i]["morning"] : false,
					afternoon: this.printPrescArray[i]["afternoon"] != undefined ? this.printPrescArray[i]["afternoon"] : false,
					evening: this.printPrescArray[i]["evening"] != undefined ? this.printPrescArray[i]["evening"] : false,
					sos: this.printPrescArray[i]["sos"] != undefined ? this.printPrescArray[i]["sos"] : false,
					medDate: this.getDateStringFromDateDMY(this.printPrescArray[i]["medDate"]),
				})
			}
		}
		prescDetails.prescArr = finalMeds;
		this.generatePdfLoader = true;
		this.apiService.getPrescriptionPdf(prescDetails).subscribe({
			next: (data: any) => {
				let pdfData: any = data["body"];
				this.blob = new Blob([pdfData], { type: 'application/pdf' });
				var today = new Date();
				var day = today.getDate() + "";
				var month = (today.getMonth() + 1) + "";
				var year = today.getFullYear() + "";
				var hour = today.getHours() + "";
				var minutes = today.getMinutes() + "";
				var seconds = today.getSeconds() + "";

				day = this.checkZero(day);
				month = this.checkZero(month);
				hour = this.checkZero(hour);
				minutes = this.checkZero(minutes);
				seconds = this.checkZero(seconds);
				let fileName = day + "-" + month + "-" + year;
				FileSaver.saveAs(this.blob, "Prescription_" + fileName + "_" + this.caseDetails.case_id + ".pdf");
				this.generatePdfLoader = false;
				this.clearPrescArray();
				this.casePrescPdfHistory();
			}, error: (error) => {
				this.toastr.error("Unable to generate pdf.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.generatePdfLoader = false;
			}
		});
	}

	checkZero(data: any) {
		if (data != undefined && data.toString().length == 1) {
			data = "0" + data;
		}
		return data;
	}

	clearPrescArray() {
		this.printPrescArray = [];
		this.prescriptionPara.chief_complaint = null;
		this.prescriptionPara.prescDoctor = null;
		this.prescriptionPara.prescUserType = "Candidate";
		this.medArray.forEach((val, key) => {
			setTimeout(() => {
				val.isChecked = false;
			}, 100);
		})
	}

	getUserName() {
		let name = "";
		try {
			name = this.navbar.user?.first_name + " " + this.navbar.user?.last_name;
			return name;
		} catch (error) {
			return name;
		}
	}

	checkValue(data: any, index: any, event: any) {
		if (data.isChecked) {
			this.printPrescArray.push(data);
		} else {
			this.printPrescArray.forEach((val: any, key: any) => {
				if (val.name === data.name) {
					this.printPrescArray.splice(key, 1);
				}
			})
		}
	}

	removeMedicine(index: any) {
		this.medArray.splice(index, 1);
		this.medArrayTemp.splice(index, 1);
		/* this.medicineMasterListArray.splice(index, 1); */
	}

	AddNewMedicine() {
		this.medArray.push(this.getNewAttr());
		this.medArrayTemp.push(this.getNewAttr());
		/* this.medicineMasterListArray.push(this.medicineMasterList); */
	}

	getNewAttr() {
		return { name: null, noOfDays: null, status: "Started", medDate: new Date() };
	}

	saveMedicines() {
		for (let i = 0; i < this.medArray.length; i++) {
			let val = this.medArray[i];
			if (val.name == undefined || val.medDate == undefined || val.medDate == null || val.name.length == 0 /* || !val.noOfDays || (!val.morning && !val.afternoon && !val.evening && !val.sos) */) {
				this.toastr.error("Required Fields", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (val.noOfDays != undefined && val.noOfDays != null && val.noOfDays != "") {
				if (isNaN(val.noOfDays)) {
					this.toastr.error("Required numbers only in No. of days", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					return;
				} else if (parseFloat(val.noOfDays) < 0) {
					this.toastr.error("Number of days should be positive", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					return;
				}
			}
			if (val.morning || val.afternoon || val.evening) {
				if (val.noOfDays == undefined || val.noOfDays == null || val.noOfDays === "") {
					this.toastr.error("No. of days required", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					$("#field_noOfDays" + i).focus();
					return;
				}
			}
		}
		let finalMeds: any = [];
		if (this.medArray.length > 0) {
			for (let i = 0; i < this.medArray.length; i++) {
				if (this.medArray[i]["addedBy"] == undefined || this.medArray[i]["addedBy"] == null) {
					this.medArray[i]["addedBy"] = this.getUserName();
				}
				if (this.medArray[i]["isSaved"]) {
					if (this.getDateStringFromDateYMD(this.medArray[i]["medDate"]) != this.medArrayTemp[i]["medDate"] || this.medArray[i]["name"] != this.medArrayTemp[i]["name"] || this.medArray[i]["qty"] != this.medArrayTemp[i]["qty"] || this.medArray[i]["morning"] != this.medArrayTemp[i]["morning"] || this.medArray[i]["afternoon"] != this.medArrayTemp[i]["afternoon"] || this.medArray[i]["evening"] != this.medArrayTemp[i]["evening"] || this.medArray[i]["sos"] != this.medArrayTemp[i]["sos"] || this.medArray[i]["noOfDays"] != this.medArrayTemp[i]["noOfDays"] || this.medArray[i]["notes"] != this.medArrayTemp[i]["notes"] /* || this.medArray[i]["status"] != this.medArrayTemp[i]["status"] */) {
						this.medArray[i]["updatedBy"] = this.getUserName();
					}
				}
				finalMeds.push({
					addedBy: this.medArray[i]["addedBy"],
					updatedBy: this.medArray[i]["updatedBy"],
					name: this.medArray[i]["name"],
					qty: this.medArray[i]["qty"],
					meals: this.medArray[i]["meals"],
					noOfDays: this.medArray[i]["noOfDays"],
					status: this.medArray[i]["status"],
					notes: this.medArray[i]["notes"],
					morning: this.medArray[i]["morning"],
					afternoon: this.medArray[i]["afternoon"],
					evening: this.medArray[i]["evening"],
					sos: this.medArray[i]["sos"],
					medDate: this.getDateStringFromDateYMD(this.medArray[i]["medDate"]),
				})
			}
		}
		try {
			for (let i = 0; i < finalMeds.length; i++) {
				delete finalMeds[i].isSaved;
				delete finalMeds[i].isCheckedForMail;
				delete finalMeds[i].showCheckboxForMail;
			}
		} catch (error) { }
		this.saveMedLoader = true;
		this.apiService.addCaseMeds({ id: this.uId, meds: JSON.stringify(finalMeds) }).subscribe({
			next: data => {
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveMedLoader = false;
				this.getCaseMedicines();
				this.medSection();
				this.clearPrescArray();
			}, error: (error) => {
				this.toastr.error("Unable to add", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveMedLoader = false;
				this.printPrescArray = [];
			}
		});
	}

	rePrescribeMedicine(index: number) {
		let obj: any = JSON.parse(JSON.stringify(this.medArray[index]));
		if (this.medArray[index].status == "Started") {
			this.medArray[index].status = "Stopped";
		}
		obj.medDate = new Date();
		obj.status = "Started";
		this.medArray.push(obj);
		this.medArrayTemp.push(obj);
		/* this.medicineMasterListArray.push(this.medicineMasterList); */
	}

	getFileName(filepath: string) {
		try {
			return filepath.split("/").reverse()[0];
		} catch (error) {
			return ""
		}
	}
}
